export default __webpack_public_path__ + "static/media/princess-cruises-nav-vertical.5911b0d2.svg";